import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import SignInPage from './components/SignInPage.tsx'
import Registration from './components/Registration.tsx'
import MainApp from './components/MainApp.tsx'
import VideoCallPage from './pages/VideoCallPage.tsx'
import EmailConfirmed from './components/EmailConfirmed.tsx'
import PasswordReset from './components/PasswordReset.tsx'
import PrivacyPolicy from './pages/PrivacyPolicy.tsx'
import TermsOfService from './pages/TermsOfService.tsx'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { initializeNativeStripe } from './services/stripeService'
import { initializeAuthPersistence } from './lib/authPersistence'
import { StatusBar, Style } from '@capacitor/status-bar'
import { isNativePlatform } from './utils/platform'
import { ThemeProvider } from './contexts/ThemeContext'

// Initialize status bar on mobile platforms
if (isNativePlatform()) {
  StatusBar.show().catch(error => {
    console.error('Failed to show status bar:', error)
  })
  // Use Light style (dark text/icons) for light backgrounds
  StatusBar.setStyle({ style: Style.Light }).catch(error => {
    console.error('Failed to set status bar style:', error)
  })
}

// Initialize auth persistence (iOS only - restores session from saved token)
initializeAuthPersistence().catch(error => {
  console.error('Failed to initialize auth persistence:', error)
})

// Initialize native Stripe on mobile platforms
initializeNativeStripe().catch(error => {
  console.error('Failed to initialize native Stripe:', error)
})

const router = createBrowserRouter([
  {path: '/', element: <App />},
  {path: '/login', element: <SignInPage />},
  {path: '/register', element: <Registration />},
  {path: '/app', element: <MainApp />},
  {path: '/video-call', element: <VideoCallPage />},
  {path: '/email-confirmed', element: <EmailConfirmed />},
  {path: '/email-verified', element: <EmailConfirmed />},
  {path: '/reset-password', element: <PasswordReset />},
  {path: '/privacy', element: <PrivacyPolicy />},
  {path: '/terms', element: <TermsOfService />},
  {path: '/__/auth/action', element: <EmailConfirmed />} // Firebase auth action handler
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </StrictMode>,
)
